export default __webpack_public_path__ + "static/share-brandpage-url@2x-48d10b9172219c7e924464c5fd8a93c4.png";